export default __webpack_public_path__ + "locales/si/VersionHistory.json?hash=0dcdb57ffa252170b6bc3357c63b8a66";